<template>
  <div class="notification-card" :class="typeClass">
    <div class="notification-content">
      <div class="notification-text">
        <span class="text">{{ getNotificationText }}</span>
        <span class="link" @click="handleLinkClick">
          {{ $t('notifications.goToSample') }}
        </span>
      </div>
    </div>
    <div class="notification-date">
      <span>{{ getFormattedDate }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'NotificationCard',
  props: {
    notification: { type: Object, required: true },
    linkText: { type: String, default: null },
  },
  computed: {
    typeClass() {
      return this.notification.been_seen
        ? 'dont-been-seen-notification'
        : 'been-seen-notification';
    },
    getFormattedDate() {
      return this.notification?.created_at ?? '';
    },
    getNotificationText() {
      const text = this.$t(
        'alert.alertMessage',
        {
          array_values: this.notification.array_values.join(', '),
          sample_code: this.notification.sample_code,
          atc: this.notification.atc_code,
          company_name: this.notification.company_name,
        },
        { interpolation: { escapeValue: false } }
      );
      // Decodificar entidades HTML de forma segura
      const temp = document.createElement('div');
      temp.innerHTML = text;
      return temp.textContent || temp.innerText || text;
    },
  },
  methods: {
    async handleLinkClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.notification.alert_report_type.includes('Parameter')) {
        this.setParamReportFocusedRowKey(
          this.notification.alert_report_id
        );

        this.$f7.views.main.router.navigate(
          '/alerts/params/reports/details',
          {
            props: { details: this.notification },
            reloadCurrent: true,
            animate: true,
            transition: 'f7-fade',
          }
        );
      } else if (
        this.notification.alert_report_type.includes(
          'ReceptionAlertReport'
        )
      ) {
        this.viewAtc(this.notification);
      } else {
        this.setSampleReportFocusedRowKey(
          this.notification.alert_report_id
        );

        this.$f7.views.main.router.navigate(
          '/alerts/sample/reports/details',
          {
            props: { details: this.notification },
            reloadCurrent: true,
            animate: true,
            transition: 'f7-fade',
          }
        );
      }

      try {
        await this.setNotificationAsSeen(this.notification.id);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(error.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
    ...mapActions('alertsParams', {
      setParamReportFocusedRowKey: 'setReportFocusedRowKey',
    }),
    ...mapActions('alertsSample', {
      setSampleReportFocusedRowKey: 'setReportFocusedRowKey',
    }),
    ...mapActions('notifications', ['setNotificationAsSeen']),
  },
};
</script>
